import gql from 'graphql-tag';

export const GET_FINANCE_PROGRAMS_SELECT_OPTIONS = gql`
  query FinanceProgramsSelectOptions($accountId: ID!) {
    financeProgramsSelectOptions: financePrograms(accountId: $accountId) {
      value: financeProgramId
      label: nameInternal
    }
  }
`;
